export default __webpack_public_path__ + "static/media/news2img2.111eb329.png";